"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2335],{

/***/ 23234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ev": function() { return /* binding */ GOODS_DETAIL; },
/* harmony export */   "FY": function() { return /* binding */ EVENT_PRICE; },
/* harmony export */   "Ir": function() { return /* binding */ RESERVE_TOURLIST; },
/* harmony export */   "Jf": function() { return /* binding */ EVENT_NOTICE; },
/* harmony export */   "Kr": function() { return /* binding */ commonEventTypeCd; },
/* harmony export */   "Nh": function() { return /* binding */ GOODS_NOTICE; },
/* harmony export */   "Ny": function() { return /* binding */ EVENT_DETAIL; },
/* harmony export */   "S7": function() { return /* binding */ commonTpCd; },
/* harmony export */   "UJ": function() { return /* binding */ commonThemaCd; },
/* harmony export */   "uk": function() { return /* binding */ commonMainMenu; }
/* harmony export */ });
/* unused harmony exports RESERVE_DETAIL, commonPromoCd, CookieName */
var RESERVE_DETAIL = {
    singleTypeCd: "",
    goodsCd: "",
    repreNm: "",
    rervNo: "",
    rervSeq: "",
    webCustNo: "",
    rervDt: "",
    evNm: "",
    evCd: "",
    evNightNm: "",
    trTp: "",
    trCompanySnm: "",
    trCompanyNm: "",
    webDisplayCls: "",
    accomNm: "",
    evStartDt: "",
    outDeprtTm: "",
    outArrvTm: "",
    outDayDiff: "",
    outFlightNm: "",
    evArriveDt: "",
    inDeprtTm: "",
    inArrvTm: "",
    inDayDiff: "",
    inFlightNm: "",
    birthDt: "",
    gender: "",
    email: "",
    mobileNo: "",
    telNo: "",
    adtCnt: "",
    chdCnt: "",
    infCnt: "",
    rervNote: "",
    adtPrice: "",
    chdPrice: "",
    infPrice: "",
    bafAdtPrice: "",
    bafChdPrice: "",
    bafInfPrice: "",
    airtaxAdtPrice: "",
    airtaxChdPrice: "",
    airtaxInfPrice: "",
    rervWorkId: "",
    workId: "",
    mgmUserInfo: "",
    mgmUserNm: "",
    mgmDeptNm: "",
    phoneDirect: "",
    emailDirect: "",
    mgmUserTelNo: "",
    mgmUserEmail: "",
    contListSeq: "",
    rervYn: "",
    etaxYn: "",
    cancelDt: "",
    discountPrice: "",
    continentCd: "",
    continentNm: "",
    countryCd: "",
    countryNm: ""
};
var EVENT_DETAIL = {
    inArrvTm: "",
    inFlightNm: "",
    webDisplayCls: "",
    trCompanySnm: "",
    fakeCnt: "",
    rervCnt: "",
    trTp: "",
    dayCnt: "",
    tourPatInfo: "",
    evStartDt: "",
    trCompanyNm: "",
    outDayDiff: "",
    avlilBlockQty: "",
    inDeprtTm: "",
    evStaCd: "",
    evArriveDt: "",
    outFlightNm: "",
    outDeprtTm: "",
    minCnt: "",
    goodsTp: "",
    inDayDiff: "",
    outArrvTm: "",
    dayStayInfo: "",
    accomNm: "",
    goodsAreaOne: "",
    goodTravelYn: "",
    evCd: "",
    evNm: "",
    goodsBrandCd: "",
    emphasisDivi: "",
    rvwAvgScore: "",
    rvwCnt: "",
    epiCnt: "",
    startCharDivi: "",
    webStartConfYn: "",
    webCancelCommiYn: "",
    webTourDayYn: "",
    webGoodsPriceYn: "",
    webAirConfYn: "",
    webAccommConfYn: "",
    webGuidConfYn: "",
    webInsolConfYn: "",
    shopCnt: "",
    goodsCd: "",
    cancelCnt: "",
    freeScheYn: "",
    expCurrCd: "",
    guideExpAmt: "",
    noTosYn: "",
    stopoverCntYn: "",
    inStovCnt: "",
    outStovCnt: "",
    singleChagYn: "",
    singleChagAmt: "",
    mgmUserInfo: "",
    mgmDeptNm: "",
    mgmUserNm: "",
    mgmUserTelNo: "",
    mgmUserEmail: "",
    phoneDirect: "",
    keypointContList: [],
    evProgDivi: "",
    evProgDiviNm: "",
    insuTargetAttr: "",
    insuTargetExpl: "",
    simpleScheYn: "",
    eventTypeCd: "",
    outUseTmhh: "",
    outUseTmmi: "",
    inUseTmhh: "",
    inUseTmmi: "",
    seatClassCd: "",
    seatClassNm: "",
    greenFeeYn: "",
    caddieFeeYn: "",
    holeCnt: 0,
    continentCd: "",
    continentNm: "",
    countryCd: "",
    countryNm: "",
    fixRervCd: null
};
var GOODS_DETAIL = {
    goodsCd: "",
    goodsNm: "",
    tourPatInfo: "",
    minPrice: 0,
    maxPrice: 0,
    minPriceDate: "",
    maxPriceDate: "",
    epiCnt: 0,
    rvwAvgScore: 0,
    rvwCnt: 0,
    goodsTp: "",
    goodsBrandCd: "",
    goodTravelYn: "",
    goodsContents: "",
    webDisplayCls: "",
    goodsTpointContents: null,
    goodsFeaturesList: null,
    goodsTmember: null,
    continentCd: "",
    continentNm: "",
    countryCd: "",
    countryNm: ""
};
var RESERVE_TOURLIST = {
    tourAgeDivi: "",
    tourListNo: "",
    tourResNmKor: "",
    tourResNmEng: "",
    mobileNo: "",
    birthDt: "",
    gender: "",
    passportAttaFileKey: "",
    tourlistSeq: "",
    ocrCheckYn: "",
    tourSaleAmt: "",
    cancelDt: ""
};
var EVENT_NOTICE = {
    evCd: "",
    singleTypeCd: "",
    trTp: "",
    goodsCd: "",
    goodsTp: "",
    daySeq: "",
    shopCnt: "",
    inclInfo: "",
    notinclInfo: "",
    miscInfo: "",
    goodsInfo: "",
    vimeoUrl: "",
    shopInfo: "",
    poliInfo: "",
    cancelInfo: "",
    optInfo: "",
    refeInfo: "",
    essenInfo: "",
    passportInfo: "",
    foldAttaFileKey: "",
    stretAttaFileKey: "",
    meetingnoyn: "",
    meetingnm: "",
    meetingtm: "",
    meetingmanager: "",
    meetingtelno: "",
    meetingnote: "",
    keyInfoImageList: [
        {
            evCd: "",
            kinfoDivi: "",
            pcAttaFilePath: "",
            moAttaFilePath: ""
        }, 
    ]
};
var EVENT_PRICE = {
    adtPrice: 0,
    chdPrice: 0,
    infPrice: 0,
    bafAdtCost: 0,
    bafChdCost: 0,
    bafInfCost: 0,
    airTaxAdtCost: 0,
    airTaxChdCost: 0,
    airTaxInfCost: 0,
    expCurrCd: "",
    guideExpAmt: 0,
    driverAmt: 0,
    depositDivi: "",
    depositDiviNm: "",
    depositAmt: 0
};
var GOODS_NOTICE = {
    goodsInfo: "",
    goodsChar: "",
    inclInfo: "",
    notinclInfo: "",
    optInfo: "",
    refeInfo: "",
    essenInfo: "",
    atteInfo: "",
    poliInfo: "",
    passportInfo: "",
    emerInfo: "",
    bankAccInfo: "",
    miscInfo: "",
    shopInfo: "",
    poliTempNm: "",
    cancelInfo: "",
    insuTempNm: "",
    rervInfoImgUrl: "",
    videoUrl: "",
    videoTitle: "",
    videoNote: "",
    videoThum: "",
    vimeoUrl: "",
    foldAttaFileKey: "",
    stretAttaFileKey: "",
    meetingnoyn: "",
    meetingtm: "",
    meetingmanager: "",
    meetingtelno: "",
    meetingnote: "",
    singleTypeCd: "",
    goodsNm: "",
    goodsTpointContents: "",
    keyInfoImageList: [],
    keypointContList: []
};
// Braze 관련
/**
 * 메뉴 코드별 이름(dspMenuCd)
 */ var commonMainMenu = {
    EJT: "투어/패스",
    PKG: "해외패키지",
    FIT: "자유여행",
    CRS: "크루즈",
    DMT: "국내여행",
    HYM: "허니문",
    GLF: "골프",
    FBD: "부산|대구출발",
    AIR: "해외항공",
    HTT: "호텔",
    YBP: "TOP PICK",
    BTM: "기업|단체",
    DMA: "국내항공(기획전용)",
    TAT: "땡처리",
    TMA: "테마여행",
    CAR: "렌터카"
};
/**
 * 추천코드별 이름(recCd)
 */ var commonEventTypeCd = {
    PRC: "출발임박",
    EAB: "얼리버드",
    RCM: "추천상품"
};
/**
 * 테마코드별 이름(themaCd)
 */ var commonThemaCd = {
    A9: "TOP PICK",
    S3: "아동동반 가족여행",
    A8: "자유허니문",
    G1: "골프텔 (2인 출발 가능)",
    G2: "골프+휴양",
    G3: "골프+관광",
    G4: "장박&전지훈련",
    J4: "어드벤쳐"
};
/**
 * 프로모션코드별 이름(promoCd)
 */ var commonPromoCd = {
    CHD: "아동할인",
    FID: "선착순 할인",
    FIB: "선착순 혜택",
    SCD: "싱글차지할인",
    TSP: "선발권 특가",
    ERB: "얼리버드",
    SPP: "특가",
    DAN: "땡처리",
    GDH: "황금연휴",
    FDA: "창립기념일",
    FAM: "가정의달"
};
var commonTpCd = {
    P: "패키지",
    K: "세미패키지",
    F: "자유여행",
    H: "허니문",
    G: "골프",
    C: "크루즈",
    R: "성지순례",
    T: "항공권",
    E: "입장권",
    J: "현지관광",
    L: "호텔",
    S: "테마상품",
    M: "MICE"
};
/**
 * account cookie
 */ var CookieName = {
    ACCESS: "YB_ACTK",
    REFRESH: "YB_RETK"
};


/***/ }),

/***/ 99346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ay": function() { return /* binding */ getAge; },
/* harmony export */   "Fj": function() { return /* binding */ getDayStayInfo; },
/* harmony export */   "HG": function() { return /* binding */ getTrafficIcon; },
/* harmony export */   "HV": function() { return /* binding */ reserveTypeText; },
/* harmony export */   "MO": function() { return /* binding */ flightLocation; },
/* harmony export */   "_f": function() { return /* binding */ reserveButtonText; },
/* harmony export */   "aS": function() { return /* binding */ getPrice; },
/* harmony export */   "fP": function() { return /* binding */ scheduleTimeText; },
/* harmony export */   "jn": function() { return /* binding */ departureStart; },
/* harmony export */   "jp": function() { return /* binding */ returnArrival; },
/* harmony export */   "mk": function() { return /* binding */ isGoodsTpFH; },
/* harmony export */   "sm": function() { return /* binding */ returnStart; },
/* harmony export */   "t9": function() { return /* binding */ departureArrival; },
/* harmony export */   "wz": function() { return /* binding */ getTrafficIconUrl; }
/* harmony export */ });
/* unused harmony exports getReserveNoticeTexts, getTourPathInfo, hrefReserveComplete, timeToDeparture, timeToReturn */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20414);
/* harmony import */ var _COMPONENTS_common_commonUtil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72425);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);





var daykor = [
    "일",
    "월",
    "화",
    "수",
    "목",
    "금",
    "토"
];
var getDayStayInfo = function(param) {
    var dayCnt = param.dayCnt, dayStayInfo = param.dayStayInfo;
    /* 여행 기간 */ if (!dayStayInfo) return null;
    return dayCnt > 0 && dayCnt < 10 ? dayStayInfo.replace("0박", "") : dayStayInfo;
};
var getTourPathInfo = function(param) {
    var _tourPatInfo = param.tourPatInfo, tourPatInfo = _tourPatInfo === void 0 ? null : _tourPatInfo;
    /* 방문 도시 */ if (!tourPatInfo) return null;
    return tourPatInfo.replace(/-/g, " → ");
};
var getTrafficIcon = function(event) {
    var trTp = event.trTp, trCompanyNm = event.trCompanyNm, seatClassCd = event.seatClassCd;
    var icons = {
        A: seatClassCd && seatClassCd !== "EC" ? "air-premium" : "air",
        T: "train",
        S: "ship",
        B: "bus"
    };
    var ref;
    return {
        icon: (ref = icons[trTp]) !== null && ref !== void 0 ? ref : "transport-not",
        name: trTp ? trCompanyNm : "교통불포함"
    };
};
/**
 * divi "out" 출발항공, "in" 도착항공
 */ var getTrafficIconUrl = function(param) {
    var trTp = param.trTp, trCompanySnm = param.trCompanySnm, inAirCd = param.inAirCd, divi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "out";
    var airCd = divi === "out" ? trCompanySnm : inAirCd;
    var STATIC_URL = _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_STATIC_CDN_URL */ .Z.ENV_STATIC_CDN_URL;
    var src = {
        A: "".concat(STATIC_URL, "/images/air/").concat(airCd, ".png"),
        T: "".concat(STATIC_URL, "/images/air/TRAIN.png"),
        S: "".concat(STATIC_URL, "/images/air/SHIP.png"),
        B: "".concat(STATIC_URL, "/images/air/BUS.png")
    }[trTp] || "".concat(STATIC_URL, "/images/air/ETC.png");
    return src;
};
var departureStart = function(param) {
    var evStartDt = param.evStartDt, outDeprtTm = param.outDeprtTm, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var startObj = dayjs__WEBPACK_IMPORTED_MODULE_2___default()(evStartDt);
    if (isMobile) {
        return "".concat(startObj.format("MM.DD"), " \n      (").concat(daykor[startObj.day()], ") ").concat(outDeprtTm && "".concat(outDeprtTm.substr(0, 2), ":").concat(outDeprtTm.substr(2)) || "");
    }
    return "".concat(startObj.format("YYYY.MM.DD"), " \n      (").concat(daykor[startObj.day()], ") ").concat(outDeprtTm && "".concat(outDeprtTm.substr(0, 2), ":").concat(outDeprtTm.substr(2)) || "");
};
var departureArrival = function(param) {
    var evStartDt = param.evStartDt, outArrvTm = param.outArrvTm, outDayDiff = param.outDayDiff;
    var startObj = dayjs__WEBPACK_IMPORTED_MODULE_2___default()(evStartDt);
    return "".concat(startObj.add(outDayDiff, "day").format("YYYY.MM.DD"), " \n  (").concat(daykor[startObj.add(outDayDiff, "day").day()], ") \n  ").concat(outArrvTm && "".concat(outArrvTm.substr(0, 2), ":").concat(outArrvTm.substr(2)) || "");
};
var returnStart = function(param) {
    var evArriveDt = param.evArriveDt, inDeprtTm = param.inDeprtTm, inDayDiff = param.inDayDiff;
    var arriveObj = dayjs__WEBPACK_IMPORTED_MODULE_2___default()(evArriveDt);
    return "".concat(arriveObj.add(-inDayDiff, "day").format("YYYY.MM.DD"), " \n  (").concat(daykor[arriveObj.add(-inDayDiff, "day").day()], ") \n  ").concat(inDeprtTm && "".concat(inDeprtTm.substr(0, 2), ":").concat(inDeprtTm.substr(2)) || "");
};
var returnArrival = function(param) {
    var evArriveDt = param.evArriveDt, inArrvTm = param.inArrvTm, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var arriveObj = dayjs__WEBPACK_IMPORTED_MODULE_2___default()(evArriveDt);
    if (isMobile) {
        return "".concat(arriveObj.format("MM.DD"), " \n		(").concat(daykor[arriveObj.day()], ") ").concat(inArrvTm && "".concat(inArrvTm.substr(0, 2), ":").concat(inArrvTm.substr(2)) || "");
    }
    return "".concat(arriveObj.format("YYYY.MM.DD"), " \n    (").concat(daykor[arriveObj.day()], ") ").concat(inArrvTm && "".concat(inArrvTm.substr(0, 2), ":").concat(inArrvTm.substr(2)) || "");
};
var timeToDeparture = function(props) {
    var outDeprtTm = props.outDeprtTm, outArrvTm = props.outArrvTm;
    if (!outDeprtTm || !outArrvTm) return "";
    var departTimeObj = dayjs(departureStart(props));
    var arrivalTimeObj = dayjs(departureArrival(props));
    var timeDiffMinutes = arrivalTimeObj.diff(departTimeObj, "minutes");
    var hours = Math.floor(timeDiffMinutes / 60);
    var minutes = timeDiffMinutes % 60;
    var formattedHours = hours.toString().padStart(2, "0");
    var formattedMinutes = minutes.toString().padStart(2, "0");
    return "총 ".concat(formattedHours, "시간 ").concat(formattedMinutes, "분");
};
var timeToReturn = function(props) {
    var inDeprtTm = props.inDeprtTm, inArrvTm = props.inArrvTm;
    if (!inDeprtTm || !inArrvTm) return "";
    var departTimeObj = dayjs(returnStart(props));
    var arrivalTimeObj = dayjs(returnArrival(props));
    var timeDiffMinutes = arrivalTimeObj.diff(departTimeObj, "minutes");
    var hours = Math.floor(timeDiffMinutes / 60);
    var minutes = timeDiffMinutes % 60;
    var formattedHours = hours.toString().padStart(2, "0");
    var formattedMinutes = minutes.toString().padStart(2, "0");
    return "총 ".concat(formattedHours, "시간 ").concat(formattedMinutes, "분");
};
var flightLocation = function(scheduleDetailTm, goodsAreaOne) {
    var result = {
        outArrvCityNm: "",
        outDeprtCityNm: "",
        inArrvCityNm: "",
        inDeprtCityNm: ""
    };
    if (!scheduleDetailTm.length) return result;
    var ref = scheduleDetailTm[0], outArrvCityNm = ref.outArrvCityNm, outDeprtCityNm = ref.outDeprtCityNm, inArrvCityNm = ref.inArrvCityNm, inDeprtCityNm = ref.inDeprtCityNm, trTp = ref.trTp;
    // 상품코드 K (국내) 이면서 운송수단이 항공이 아닌경우
    if (goodsAreaOne === "K" && trTp !== "A") return result;
    return {
        outArrvCityNm: outArrvCityNm,
        outDeprtCityNm: outDeprtCityNm,
        inArrvCityNm: inArrvCityNm,
        inDeprtCityNm: inDeprtCityNm
    };
};
/** 총 소요시간 ex) 총 hh시간 mi분 */ var scheduleTimeText = function(param) {
    var _hh = param.hh, hh = _hh === void 0 ? "" : _hh, _mi = param.mi, mi = _mi === void 0 ? "" : _mi;
    if (!hh || !mi) return "";
    return "총 ".concat(hh ? "".concat(hh, "시간") : "", " ").concat(mi ? "".concat(mi, "분") : "");
};
var getPrice = function(price) {
    if (!price) return null;
    var adtPrice = price.adtPrice, bafAdtCost = price.bafAdtCost, airTaxAdtCost = price.airTaxAdtCost, chdPrice = price.chdPrice, bafChdCost = price.bafChdCost, airTaxChdCost = price.airTaxChdCost, infPrice = price.infPrice, bafInfCost = price.bafInfCost, airTaxInfCost = price.airTaxInfCost;
    var adult = Number(adtPrice + bafAdtCost + airTaxAdtCost);
    var child = Number(chdPrice + bafChdCost + airTaxChdCost);
    var infant = Number(infPrice + bafInfCost + airTaxInfCost);
    return {
        adult: adult,
        child: child,
        infant: infant
    };
};
/* 만 나이 구하기 */ var getAge = function() {
    var yyyyMMdd = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", stdDt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var regExpStDt = /(\d{4})[.|-]*(\d{2})[.|-]*(\d{2})/.exec(stdDt);
    var regExpInpDt = /(\d{4})[.|-]*(\d{2})[.|-]*(\d{2})/.exec(yyyyMMdd);
    var startDt = regExpStDt ? new Date(Number(regExpStDt[1]), Number(regExpStDt[2]), Number(regExpStDt[3])) : new Date();
    var inputDt = new Date(Number(regExpInpDt[1]), Number(regExpInpDt[2]), Number(regExpInpDt[3]));
    var years = startDt.getFullYear() - inputDt.getFullYear();
    inputDt.setFullYear(startDt.getFullYear());
    if (startDt < inputDt) years--;
    return years;
};
/** 허니문 에어텔 여부 */ var isGoodsTpFH = function(goodsTp) {
    return [
        "F",
        "H"
    ].indexOf(goodsTp) > -1;
};
var getReserveNoticeKey = function(goodsTp, fixRervCd) {
    if (goodsTp === "F") return "F";
    if (goodsTp === "H") return "H";
    if (fixRervCd === "ND") return "ND";
    if (fixRervCd === "YT") return "YT";
    return "DEFAULT";
};
/* 예약 안내사항 문구 (모바일/데스크탑 공용) */ var RESERVE_NOTICE_TEXTS = {
    // 안내사항_자유여행
    F: [
        "홈페이지를 통한 예약은 확정이 아닌 접수 상태이며, 담당자 확인 후 최종 요금 및 예약 확정이 진행됩니다.",
        "예약금은 예약 확정 후 담당자를 통해 안내되며, 지정 시간 내 예약금을 결제하지 않으신 경우 예약이 임의 취소될 수 있습니다.",
        "항공권 또는 항공권이 포함된 상품의 경우 세금 및 예상 유류할증료가 포함된 가격이며, 유류할증료는 유가 및 환율에 따라 변동될 수 있습니다.",
        "최저 항공료 좌석 마감 시 또는 여행하는 날짜의 현지 박람회 행사 등에 의해 추가요금이 발생할 수 있습니다.",
        "아동/유아 기준은 항공사마다 상이하여 예약 후 최종 확정됩니다.",
        "모든 상품의 호텔은 2인 1실 사용 기준의 1인 요금입니다. 1인 1실 사용 시 추가요금이 발생될 수 있고, 성수기 기간은 리조트별 서차지가 발생할 수 있습니다.", 
    ],
    // 안내사항_허니문
    H: [
        "본 상품은 허니문 전용 상품으로 비허니문일 경우 패널티가 부과될 수 있습니다. (지역별 상이)",
        "예약금은 예약 확정 후 담당자를 통해 안내되며, 지정 시간 내 예약금을 결제하지 않으신 경우 예약이 임의 취소될 수 있습니다.",
        "항공권 또는 항공권이 포함된 상품의 경우 세금 및 예상 유류할증료가 포함된 가격이며, 유류할증료는 유가 및 환율에 따라 변동될 수 있습니다.",
        "최저 항공료 좌석 마감 시 또는 여행하는 날짜의 현지 박람회 행사 등에 의해 추가요금이 발생할 수 있습니다.",
        "아동/유아 기준은 항공사마다 상이하여 예약 후 최종 확정됩니다.",
        "모든 상품의 호텔은 2인 1실 사용 기준의 1인 요금입니다. 1인 1실 사용 시 추가요금이 발생될 수 있고, 성수기 기간은 리조트별 서차지가 발생할 수 있습니다.",
        "일정표에 제공되는 프로그램은 고객 개인 사정으로 불참 시 환불되지 않습니다.", 
    ],
    // 안내사항_기본_가예약(예약금)
    ND: [
        "예약금 결제 시 '예약 접수' 상태로 진행되며, 담당자 확인 후 최종 확정됩니다.",
        "예약 확정 전까지 마이페이지, 고객센터를 통해 예약 취소 및 예약금 전액 환불이 가능합니다.",
        "확정 이후 취소 시 위약금이 발생할 수 있으니 행사별 약관을 반드시 확인하시기 바랍니다.",
        "항공권 포함 상품의 경우 세금 및 예상 유류할증료가 포함된 가격이며, 유가 및 환율에 따라 변동될 수 있습니다.",
        "아동\xb7유아 요금은 항공사마다 상이하여 예약 확정 시 담당자가 안내드립니다.", 
    ],
    // 안내사항_기본_실예약(전액)
    YT: [
        "본 상품은 전액 결제 완료 시 여행 계약이 즉시 체결 및 예약 확정됩니다.",
        "항공권 포함 상품은 세금 및 유류할증료가 포함된 금액이며, 결제 완료 후 가격 변동 없이 확정됩니다.",
        "결제 미완료 시 좌석이 확보되지 않을 수 있으니 예약과 동시에 결제를 완료해 주세요.",
        "확정 이후 취소 시 위약금이 발생할 수 있으니 행사별 약관을 반드시 확인하시기 바랍니다.", 
    ],
    // 안내사항_기본_확정예약값 사용안함
    DEFAULT: [
        "홈페이지 예약은 '예약 접수' 상태로 진행되며, 담당자 확인 후 최종 요금 및 예약이 확정됩니다.",
        "예약 확정 전까지 마이페이지, 고객센터를 통해 예약 취소가 가능합니다.",
        "예약금은 확정 후 담당자를 통해 안내되며, 지정 시간 내 미결제 시 예약이 임의 취소될 수 있습니다.",
        "확정 이후 취소 시 위약금이 발생할 수 있으니 행사별 약관을 반드시 확인하시기 바랍니다.",
        "항공권 포함 상품의 경우 세금 및 예상 유류할증료가 포함된 가격이며, 유가 및 환율에 따라 변동될 수 있습니다.",
        "아동\xb7유아 요금은 항공사마다 상이하여 예약 확정 시 담당자가 안내드립니다.", 
    ]
};
var getReserveNoticeTexts = function(goodsTp) {
    var fixRervCd = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return RESERVE_NOTICE_TEXTS[getReserveNoticeKey(goodsTp, fixRervCd)];
};
/* 예약하기버튼 */ var reserveButtonText = function(event) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
    if (!event) return [
        "disabled",
        ""
    ];
    var today = dayjs__WEBPACK_IMPORTED_MODULE_2___default()();
    if (dayjs__WEBPACK_IMPORTED_MODULE_2___default()(event.evStartDt) <= today) return [
        "disabled",
        "출발완료"
    ];
    if (event.evStaCd === "05") return [
        "disabled",
        "예약마감"
    ];
    if (isGoodsTpFH(event.goodsTp)) return [
        "mainCtn",
        "예약접수"
    ];
    if (!isGoodsTpFH(event.goodsTp) && event.evStaCd !== "05" && event.avlilBlockQty === 0) return [
        "mainCtn",
        "대기예약"
    ];
    if (event.fixRervCd === "YT" && type === "reserve") return [
        "mainCtn",
        "전액 결제"
    ];
    if (event.fixRervCd === "ND" && type === "reserve") return [
        "mainCtn",
        "예약금 결제"
    ];
    return [
        "mainCtn",
        "예약하기"
    ];
};
var reserveTypeText = function(event) {
    if (!event) return "";
    if (isGoodsTpFH(event.goodsTp)) return "예약접수";
    if (!isGoodsTpFH(event.goodsTp) && event.evStaCd !== "05" && event.avlilBlockQty === 0) return "대기예약";
    return "일반예약";
};
var hrefReserveComplete = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(props) {
        var rervNo, fixRervCd, repreNm, webCustNo, rervCd, returnUrl, form, appendField;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            rervNo = props.rervNo, fixRervCd = props.fixRervCd, repreNm = props.repreNm, webCustNo = props.webCustNo;
            rervCd = fixRervCd !== null && fixRervCd !== void 0 ? fixRervCd : "DF";
            returnUrl = fixRervCd !== null ? "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_TRAVEL_URL */ .Z.ENV_TRAVEL_URL, "/pkg/pay?rervNo=").concat(rervNo, "&rervCd=").concat(rervCd) // 결제 페이지 이동
             : "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_TRAVEL_URL */ .Z.ENV_TRAVEL_URL, "/pkg/reserve/complete?rervNo=").concat(rervNo, "&rervCd=").concat(rervCd); // 완료 페이지 이동
            // 비회원 로그인 처리 (브릿지는 리다이렉트이므로 전체 페이지 POST submit)
            if (!webCustNo && repreNm && rervNo) {
                if (typeof document === "undefined") return [
                    2
                ];
                form = document.createElement("form");
                form.method = "POST";
                form.action = "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_ACCOUNTS_API_DOMAIN */ .Z.ENV_ACCOUNTS_API_DOMAIN, "/bridge/nonuser-auth");
                form.style.display = "none";
                appendField = function(name, value) {
                    var input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                };
                appendField("rervNo", rervNo);
                appendField("custNm", repreNm);
                appendField("channelCode", "travel001");
                appendField("returnUrl", returnUrl);
                document.body.appendChild(form);
                form.submit();
                return [
                    2
                ];
            }
            return [
                2,
                (0,_COMPONENTS_common_commonUtil__WEBPACK_IMPORTED_MODULE_0__/* .replaceSSO */ .MR)(returnUrl)
            ];
        });
    });
    return function hrefReserveComplete(props) {
        return _ref.apply(this, arguments);
    };
}();



/***/ })

}]);